<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
html {
  font-size: 16px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}

.justify-around {
  display: flex;
  justify-content: space-around;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.items-start {
  display: flex;
  align-items: flex-start;
}

.items-center {
  display: flex;
  align-items: center;
}

.items-end {
  display: flex;
  align-items: flex-end;
}
.view {
  width: 100%;
  height: 100%;
}
#app .el-table .has-gutter {
  color: #fff;
}
.el-table .has-gutter th.el-table__cell {
  background: #1d7bfc;
}
#app .el-table .has-gutter .cell {
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
#app .el-button--primary {
  background-color: #1d7bfc;
  border-color: #1d7bfc;
}
.pagination {
  /* height: 50px; */
  margin-top: 10px;
  padding: 0 30px;
}
#app .tablefixed.is-leaf {
  background-color: #1d7bfc;
  color: #fff;
  font-weight: 500;
}
#app .tablefixed.is-leaf .cell {
  font-size: 16px;
}
</style>
